import {
    addDoc,
    collection,
    doc,
    getDocs,
    updateDoc,
    query,
    where
} from "firebase/firestore";
import { db } from "./firebase";

const stripeProductsCollection = collection(db, "StripeProducts");

class StripeProductService {

    getAll = () => {
        return getDocs(stripeProductsCollection);
    };

    getByProductId = async (productId) => {
        const q = query(
            stripeProductsCollection,
            where("productId", "==", productId)
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.length > 0
            ? { id: snapshot.docs[0].id, ...snapshot.docs[0].data() }
            : null;
    };

    add = (data) => {
        return addDoc(stripeProductsCollection, data);
    };

    update = (docId, data) => {
        const ref = doc(db, "StripeProducts", docId);
        return updateDoc(ref, data);
    };
}

export default new StripeProductService();
